import { useHTTP, useHTTPQueryWithCursor, type PaginatedResponseModel } from "@/lib/http";
import type { PriceAlertDetailsModel } from "@/features/priceAlerts/api/models/PriceAlertDetailsModel";

export const usePriceAlertDetails = () => {
	const http = useHTTP("Required");
	return useHTTPQueryWithCursor({
		queryKey: ["priceAlertDetails"],
		queryFn: ({ pageParam = 0 }) => {
			return http<PaginatedResponseModel<PriceAlertDetailsModel>>({
				method: "GET",
				url: `/price-alert?cursor=${pageParam}`
			});
		}
	});
};
